import React, { FC } from "react";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
} from '../create-subnet/styles'
import { icons } from "../../../icons";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import * as yup from 'yup';
import { useFormik } from 'formik';
import Input from "../../input";
import { HeadLine3 } from "../../typography/styled";

type ModalProps = {
  closeModalCancel: () => void;
  closeModal: (props?: any) => void;
  dataToEdit?: any;
  loading?: boolean;
  alertTitle?: string;
}

const ProductGroupEdit: FC<ModalProps> = (props) => {
  const {
    closeModal,
    closeModalCancel,
    dataToEdit,
    loading,
  } = props
  const [t] = useTranslation()

  const onSubmit = (values: any) => {
    closeModal({
      id: dataToEdit?.id,
      name: values.name,
      description: values.description,
    })
  }

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(`${t("REQUIRED_FIELD")}`),
      description: yup.string(),
    }),
    initialValues: {
      name: dataToEdit?.name || '',
      description: dataToEdit?.description || '',
    },
    onSubmit,
  });

  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };

  return (
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{ marginLeft: '10px', marginTop: '10px' }}>
          {dataToEdit?.id ? t("EDIT_PRODUCT_GROUP") : t("CREATE_PRODUCT_GROUP")}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon} />
      </HeadWrapper>
      <BodyModal>
        <Input
          required
          title={t('NAME')}
          fieldName='name'
          placeholder=''
          onBlur={handleBlur}
          customStyles={{ width: '360px' }}
          {...formikProps}
        />
        <Input
          title={t('DESCRIPTION')}
          fieldName='description'
          placeholder=''
          isTextArea
          onBlur={handleBlur}
          customStyles={{ width: '360px' }}
          {...formikProps}
        />
        <div style={{ display: "flex", gap: '6px', marginTop: '14px' }}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '177px', justifyContent: 'center' }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          />
          <Button
            variant="primary"
            size="display"
            customStyles={{ width: '177px', justifyContent: 'center' }}
            onClick={handleSubmit}
            loading={loading}
            title={dataToEdit?.id ? t("SAVE") : t("CREATE")}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default ProductGroupEdit
